module.exports = __webpack_public_path__ + "img/lingdao.b722b2c7.png";